/* CUSTOMERS */

import Login from '@/views/auth/login.vue';
import AuthCallback from '@/views/auth/callback.vue';
import AuthLogoutCallback from '@/views/auth/logoutCallback.vue';
import BasicNSLayout from '@/views/layouts/basicNoSideMenu.vue';
import ForgotPassword from '@/views/auth/forgotPassword.vue';
import SetPassword from '@/views/auth/setPassword.vue';

/* ROUTER
-------------------------------------------------------------- */
export default {
  path: 'auth',
  name: 'auth',
  meta: {title: 'Inloggen'},
  redirect: '/auth/login',
  component: BasicNSLayout,
  children: [
    {
      path: 'login',
      name: 'auth.login',
      meta: {
        title: 'Inloggen',
        requiresAuth: false,
        guestOnly: true,
      },
      component: Login,
    },
    {
      path: 'wachtwoord-vergeten',
      name: 'auth.forgotPassword',
      meta: {
        title: 'Wachtwoord vergeten',
        requiresAuth: false,
        guestOnly: true,
      },
      component: ForgotPassword,
    },
    {
      path: 'wachtwoord-instellen',
      name: 'auth.setPassword',
      meta: {
        title: 'Wachtwoord instellen',
        requiresAuth: false,
        guestOnly: true,
      },
      component: SetPassword,
    },
    {
      path: 'callback',
      name: 'auth.callback',
      meta: {
        title: 'Inloggen...',
        requiresAuth: false,
      },
      component: AuthCallback,
    },
    {
      path: 'logout-callback',
      name: 'auth.logoutCallback',
      meta: {
        title: 'Uitloggen...',
        requiresAuth: false,
      },
      component: AuthLogoutCallback,
    },
  ],
};
